import type { TFunction } from 'i18next';
import { StatisticType } from '../types/dashboard.type';
import { EsgMonthlyMetricType } from '../types/esg-monthly-metric.type';
import type { EsgOverviewWidgetId } from '../types/esg-overview-widget.type';
import { ESG_OVERVIEW_WIDGET_LABELS } from '../types/esg-overview-widget.type';

export function getMetricLabel(t: TFunction, metricKey: string): string {
  const key = `metrics.${metricKey}`;
  const translated = t(key);
  return translated !== key ? translated : metricKey.replace(/_/g, ' ');
}

export function getEsgMonthlyMetricLabel(t: TFunction, metric: EsgMonthlyMetricType): string {
  return getMetricLabel(t, metric);
}

export function getStatisticLabel(t: TFunction, stat: StatisticType | string): string {
  if (stat === StatisticType.AVERAGE_INCENTIVE_PER_KG) {
    return t('dashboard.avgPrice');
  }
  const key = `metrics.${String(stat).toLowerCase()}`;
  const translated = t(key);
  if (translated !== key) return translated;
  return String(stat).replace(/_/g, ' ').toUpperCase();
}

export function getKnowledgeCategoryLabel(
  t: TFunction,
  category: string
): string {
  const key = `knowledgeBase.categories.${category}`;
  const translated = t(key);
  return translated !== key ? translated : category;
}

export function getOverviewWidgetLabel(t: TFunction, id: EsgOverviewWidgetId): string {
  const key = `dashboard.overviewWidgets.${id}`;
  const translated = t(key);
  return translated !== key ? translated : ESG_OVERVIEW_WIDGET_LABELS[id];
}
